document.addEventListener('DOMContentLoaded', () => {
	  const toggleBtn = document.querySelector('.toggle-nav');
	  const offcanvas = document.getElementById('offcanvas-menu');
	  const overlay = document.getElementById('overlay');
	  const closeBtn = document.getElementById('close-btn');
	  const video = document.querySelector('.about__video-element');
	  const playButton = document.querySelector('.about__video-play');
	  const container = document.querySelector('.container');
	  const lessonsContainer = document.querySelector('.lessons__container');
	
	  // Offcanvas menu
	  toggleBtn?.addEventListener('click', () => {
		offcanvas?.classList.add('show');
		overlay?.classList.add('show');
	  });
	
	  closeBtn?.addEventListener('click', () => {
		offcanvas?.classList.remove('show');
		overlay?.classList.remove('show');
	  });
	
	  overlay?.addEventListener('click', () => {
		offcanvas?.classList.remove('show');
		overlay?.classList.remove('show');
	  });
	
	  // 🎬 Video play/pause toggle logic
	  if (video && playButton) {
		// Play when clicking play button
		playButton.addEventListener('click', () => {
		  video.play();
		  playButton.classList.add('hidden');
		});
	
		// Toggle pause/play when clicking on video
		video.addEventListener('click', () => {
		  if (video.paused) {
			video.play();
			playButton.classList.add('hidden');
		  } else {
			video.pause();
			playButton.classList.remove('hidden');
		  }
		});
	
		// When video ends, show play icon again
		video.addEventListener('ended', () => {
		  playButton.classList.remove('hidden');
		});
	  }
	
	  // Left padding logic
	  if (container && lessonsContainer) {
		const leftSpace = container.getBoundingClientRect().left;
		lessonsContainer.style.paddingLeft = leftSpace + 'px';
	  }

	  // Social feeds slider
	  const socialFeeds = document.querySelector('.social-feeds');
	  if (socialFeeds) {
		new Swiper(socialFeeds, {
		  loop: true,
		  spaceBetween:0,
		  speed: 600,
		  autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		  },
		  pagination: {
			el: socialFeeds.querySelector('.swiper-pagination'),
			clickable: true,
		  },
		  slidesPerView: 1,
		  breakpoints: {
			480: {
			  slidesPerView: 1,
			},
			576: {
			  slidesPerView: 3,
			},
			768: {
			  slidesPerView: 4,
			},
			1024: {
			  slidesPerView: 5,
			},
		  },
		});
	  }
});